const devConfig = {
  CLIENT_HOST: 'devmaj-my.sunrundev.com',
  MIXPANEL_KEY: '',
};

export default devConfig;
